import { DataTable } from '@/components/data-table'
import { useNavigate } from '@/libs/router'
import type { Table } from '@/libs/table'
import { useCallback } from 'react'
import type { CompanyWorkflow } from '../domain/workflow'
import { EmptyState, NoResults } from './workflows-empty-states'
import { useWorkflowListParams } from './use-workflow-list-params'

const sortableColumns = new Set(['name', 'status'])

type Props = {
	data: CompanyWorkflow[]
	hasFilters: boolean
	table: Table<CompanyWorkflow>
}

const WorkflowsTable = ({ data, hasFilters, table }: Props) => {
	const { sortBy, sortDir, setParams } = useWorkflowListParams()
	const navigate = useNavigate()

	const handleSort = useCallback(
		(key: string) => {
			if (sortBy !== key) return setParams({ sortBy: key, sortDir: 'asc' })
			if (sortDir === 'asc') return setParams({ sortBy: key, sortDir: 'desc' })
			setParams({ sortBy: null, sortDir: null })
		},
		[sortBy, sortDir, setParams],
	)

	const handleRowClick = useCallback(
		(workflowId: string) => {
			navigate({ to: '/tasks/workflows/$workflowId/edit', params: { workflowId } })
		},
		[navigate],
	)

	if (!data.length && hasFilters) return <NoResults />
	if (!data.length) return <EmptyState />

	return (
		<DataTable
			table={table}
			sortBy={sortBy}
			sortDir={sortDir}
			sortableColumns={sortableColumns}
			onSort={handleSort}
			onRowClick={handleRowClick}
			height='calc(100vh - 260px)'
		/>
	)
}

export { WorkflowsTable }
